import { createBrowserRouter, Navigate } from 'react-router-dom';

import { routerAdvertiser } from 'app/router/RouterAdvertiser';
import { routerPublic } from 'app/router/RouterPublic';
import { routerPublisher } from 'app/router/RouterPublisher';
import { EMainRoutes } from 'shared/typings';

export const routerAdvPubApp = createBrowserRouter(
	[...routerAdvertiser, ...routerPublisher, ...routerPublic,
		{
			path: '*',
			element: (
				<Navigate
					replace
					to={{ pathname: `/${EMainRoutes.ADVERTISER}/`, search: window.location.search }}
				/>
			)
		}
	]
);
